export const MODAL_TRAVEL_TO_LOCATION_TEXT = {
	confirmBtn: 'Confirm',
	travelingDetails: 'Traveling details',
	travelToLocation: 'Travel to location',
	travelPopupDescription:
		'Specify the traveling location and and time of this activity for the driver.',
	closeBtn: 'Close',
	cancelBtn: 'Cancel',
	startDateAndTime: 'Start date and time',
	endDateAndTime: 'End date and time',
	endTime: 'End time',
	fromLocation: 'From location',
	toLocation: 'To location',
};
